/**
 * @Author: DJ
 * @Date:   2021-07-10 11:17:40
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-06 19:33:19
 */
 import http from '@/assets/api/http';

 // 下载导入失败原因
 export async function emportFailDeliveryExcel(params){
     return http('/?cmd=com.xqxc.api.pig.mis.order.DeliveryExcelService.emportFailDeliveryExcel&',params,'POST');
 }
 
 // 获取批量导入订单模板
 export async function getDeliveryExcelImportUrl(params){
     return http('/?cmd=com.xqxc.api.pig.mis.order.DeliveryExcelService.getDeliveryExcelImportUrl&',params,'POST');
 }
 
 // 获取文件解析进度
 export async function getImportDeliveryExcelRate(params){
     return http('/?cmd=com.xqxc.api.pig.mis.order.DeliveryExcelService.getImportDeliveryExcelRate&',params,'POST', false);
 }
 
 // 解析订单导入文件并入库
 export async function importDeliveryExcel(params){
     return http('/?cmd=com.xqxc.api.pig.mis.order.DeliveryExcelService.importDeliveryExcel&',params,'POST');
 }
 
 // 删除导入订单
 export async function deletePreDelivery(params){
     return http('/?cmd=com.xqxc.api.pig.mis.order.PreDeliveryService.deletePreDelivery&',params,'POST');
 }
 
 // 获取导入订单详情
 export async function getPreDeliveryDetail(params){
     return http('/?cmd=com.xqxc.api.pig.mis.order.PreDeliveryService.getPreDeliveryDetail&',params,'POST');
 }
 
 // 获取导入订单列表
 export async function getPreDeliveryList(params){
     return http('/?cmd=com.xqxc.api.pig.mis.order.PreDeliveryService.getPreDeliveryList&',params,'POST');
 }
 
  // 更新导入订单普通信息
  export async function updatePreDelivery(params){
    return http('/?cmd=com.xqxc.api.pig.mis.order.PreDeliveryService.updatePreDelivery&',params,'POST');
}


 // 解析订单导入文件并入库
 export async function importDelivery(params){
    return http('/?cmd=com.xqxc.api.pig.mis.order.MisMicroOrderDeliveryService.importDelivery',params,'POST');
}